import * as g from "react";
import o from "./chunk901.js";
import $ from "./chunk1068.js";
import F from "./chunk829.js";
import { jsx as i } from "react/jsx-runtime";
import I from "./chunk834.js";
import q from "./chunk932.js";
import { getSnackbarUtilityClass as U } from "./chunk1069.js";
import s from "./chunk924.js";
import { useDefaultProps as W } from "./chunk954.js";
import G from "./chunk1035.js";
import { ClickAwayListener as V } from "./chunk991.js";
import X from "./chunk1070.js";
import _ from "./chunk957.js";
import J from "./chunk1017.js";
const K = (n) => {
  const {
    classes: t,
    anchorOrigin: r
  } = n, e = {
    root: ["root", `anchorOrigin${s(r.vertical)}${s(r.horizontal)}`]
  };
  return _(e, U, t);
}, y = I("div", {
  name: "MuiSnackbar",
  slot: "Root",
  overridesResolver: (n, t) => {
    const {
      ownerState: r
    } = n;
    return [t.root, t[`anchorOrigin${s(r.anchorOrigin.vertical)}${s(r.anchorOrigin.horizontal)}`]];
  }
})(q(({
  theme: n
}) => ({
  zIndex: (n.vars || n).zIndex.snackbar,
  position: "fixed",
  display: "flex",
  left: 8,
  right: 8,
  justifyContent: "center",
  alignItems: "center",
  variants: [{
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top",
    style: {
      top: 8,
      [n.breakpoints.up("sm")]: {
        top: 24
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical !== "top",
    style: {
      bottom: 8,
      [n.breakpoints.up("sm")]: {
        bottom: 24
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.horizontal === "left",
    style: {
      justifyContent: "flex-start",
      [n.breakpoints.up("sm")]: {
        left: 24,
        right: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.horizontal === "right",
    style: {
      justifyContent: "flex-end",
      [n.breakpoints.up("sm")]: {
        right: 24,
        left: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.horizontal === "center",
    style: {
      [n.breakpoints.up("sm")]: {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
      }
    }
  }]
}))), Q = /* @__PURE__ */ g.forwardRef(function(t, r) {
  const e = W({
    props: t,
    name: "MuiSnackbar"
  }), l = F(), k = {
    enter: l.transitions.duration.enteringScreen,
    exit: l.transitions.duration.leavingScreen
  }, {
    action: O,
    anchorOrigin: {
      vertical: p,
      horizontal: C
    } = {
      vertical: "bottom",
      horizontal: "left"
    },
    autoHideDuration: x = null,
    children: v,
    className: P,
    ClickAwayListenerProps: S,
    ContentProps: T,
    disableWindowBlurListener: w = !1,
    message: z,
    onBlur: Y,
    onClose: Z,
    onFocus: oo,
    onMouseEnter: to,
    onMouseLeave: no,
    open: u,
    resumeHideDuration: ro,
    TransitionComponent: m = J,
    transitionDuration: f = k,
    TransitionProps: {
      onEnter: d,
      onExited: b,
      ...E
    } = {},
    ...j
  } = e, a = {
    ...e,
    anchorOrigin: {
      vertical: p,
      horizontal: C
    },
    autoHideDuration: x,
    disableWindowBlurListener: w,
    TransitionComponent: m,
    transitionDuration: f
  }, D = K(a), {
    getRootProps: R,
    onClickAway: L
  } = $({
    ...a
  }), [M, h] = g.useState(!0), A = G({
    elementType: y,
    getSlotProps: R,
    externalForwardedProps: j,
    ownerState: a,
    additionalProps: {
      ref: r
    },
    className: [D.root, P]
  }), N = (c) => {
    h(!0), b && b(c);
  }, B = (c, H) => {
    h(!1), d && d(c, H);
  };
  return !u && M ? null : /* @__PURE__ */ i(V, {
    onClickAway: L,
    ...S,
    children: /* @__PURE__ */ i(y, {
      ...A,
      children: /* @__PURE__ */ i(m, {
        appear: !0,
        in: u,
        timeout: f,
        direction: p === "top" ? "down" : "up",
        onEnter: B,
        onExited: N,
        ...E,
        children: v || /* @__PURE__ */ i(X, {
          message: z,
          action: O,
          ...T
        })
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Q.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: o.node,
  /**
   * The anchor of the `Snackbar`.
   * On smaller screens, the component grows to occupy all the available width,
   * the horizontal alignment is ignored.
   * @default { vertical: 'bottom', horizontal: 'left' }
   */
  anchorOrigin: o.shape({
    horizontal: o.oneOf(["center", "left", "right"]).isRequired,
    vertical: o.oneOf(["bottom", "top"]).isRequired
  }),
  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   * @default null
   */
  autoHideDuration: o.number,
  /**
   * Replace the `SnackbarContent` component.
   */
  children: o.element,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * Props applied to the `ClickAwayListener` element.
   */
  ClickAwayListenerProps: o.object,
  /**
   * Props applied to the [`SnackbarContent`](https://mui.com/material-ui/api/snackbar-content/) element.
   */
  ContentProps: o.object,
  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   * @default false
   */
  disableWindowBlurListener: o.bool,
  /**
   * When displaying multiple consecutive snackbars using a single parent-rendered
   * `<Snackbar/>`, add the `key` prop to ensure independent treatment of each message.
   * For instance, use `<Snackbar key={message} />`. Otherwise, messages might update
   * in place, and features like `autoHideDuration` could be affected.
   */
  key: () => null,
  /**
   * The message to display.
   */
  message: o.node,
  /**
   * @ignore
   */
  onBlur: o.func,
  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {React.SyntheticEvent<any> | Event} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`, or `"escapeKeyDown"`.
   */
  onClose: o.func,
  /**
   * @ignore
   */
  onFocus: o.func,
  /**
   * @ignore
   */
  onMouseEnter: o.func,
  /**
   * @ignore
   */
  onMouseLeave: o.func,
  /**
   * If `true`, the component is shown.
   */
  open: o.bool,
  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: o.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: o.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: o.oneOfType([o.number, o.shape({
    appear: o.number,
    enter: o.number,
    exit: o.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: o.object
});
export {
  Q as default
};
